export const EXPORT_FIELD_MAPPING: Record<string, string> = {
  ORDER_NAME: "order_name",
  TRACK_NUMBER: "tracking_number",
  COURIER: 'courier',
  BOOKING_DATE: "booking_date",
  COD: "cod",
  DESTINATION_CITY: "destination_city",
  BOOKED_PACKET_STATUS: "booked_packet_status",
  PAYMENT_STATUS: "payment_status",
  DELIVERED_DATE: "delivered_date",
  BOOKED_BY: "booked_by",
  BOOKED_DAYS: "booked_days",
  TAG: "tag"
  };